<template>
  <v-container fluid ma-0 pa-0>
    <!-- CONTENT -->
    <v-flex class="section-1 general-bg" ma-0 pt-4 px-4>
      <h3 class="text-xs-left pt-2">Reporte condición actual</h3>
      <h4 class="text-xs-left pt-2">Vehículos</h4>
      <!-- BUTTON -->
      <v-flex class="text-xs-center" py-3>
          <!-- :href="urlReportPoint" -->
        <v-btn
          v-if="!reportReadyGCCR"
          color="primary"
          block
          :loading="$loading.isLoading('fetchCurrentConditionReport')"
          @click="getCurrentConditionReport"
        >
          <v-icon left>description</v-icon>
          Generar Reporte
        </v-btn>
        <v-btn
          v-if="reportReadyGCCR"
          :href="urlReportGCCR"
          target="_blank"
          color="success"
          block
          @click="toggleBtnGCCR(false)"
        >
          <v-icon left>cloud_download</v-icon>
          Descargar Reporte
        </v-btn>
      </v-flex>
    </v-flex>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'report-current-condition',
  computed: {
    ...mapGetters(['reportReadyGCCR', 'urlReportGCCR'])
  },
  methods: {
    ...mapActions(['toggleBtnGCCR', 'getCurrentConditionReport'])
  }
}
</script>

<style lang="stylus" scoped>
h3
  font-size 30px
  font-weight 500
  line-height 7px

h4
  font-size 21px
  font-weight 500

.section-1
  min-width 390px
  max-width 390px
  
.general-bg
  background-color #424242
  border-radius 3px

</style>



// WEBPACK FOOTER //
// src/components/Reports/ReportCurrentCondition.vue